import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1 } from '../apis.js';
const api = collectionEngineV1('/interaction-categories');
export const getAll = () => api('GET', `/`);
export const getInsights = (period) => api('GET', `/insights?${toQuery(period)}`);
export const listCategorizedInteractions = (period, categoryId) => api('GET', `/insights/interactions?${toQuery({ ...period, categoryId: categoryId ?? undefined })}`);
export const create = (category) => api('POST', `/`, {
    body: category,
});
export const update = (id, category) => api('PATCH', `/${id}`, {
    body: category,
});
export const applyToInteraction = (interactionId, interactionCategoryId) => api('POST', `/${interactionCategoryId}/apply-to/${interactionId}`);
export const removeFromInteraction = (interactionId, interactionCategoryId) => api('DELETE', `/${interactionCategoryId}/applied-to/${interactionId}`);
//# sourceMappingURL=interaction-categories.js.map